<script setup lang="ts">
import { type TextFieldProps, useTextField } from "@formwerk/core";

const props = withDefaults(defineProps<TextFieldProps & { hideLabel?: boolean }>(), { hideLabel: false });
const { inputProps, labelProps, errorMessage, errorMessageProps, descriptionProps, isTouched } = useTextField(props);
</script>

<template>
  <div>
    <label v-bind="labelProps" :class="{ 'sr-only': hideLabel }">
      {{ label }}
      <UiFieldRequired v-if="required" />
    </label>
    <input v-bind="inputProps" class="w-full">
    <div v-if="isTouched && errorMessage" v-bind="errorMessageProps" class="text-sm text-danger">
      {{ errorMessage }}
    </div>
    <div v-if="description" v-bind="descriptionProps" class="text-sm text-muted">
      {{ description }}
    </div>
  </div>
</template>
